import { alpha, styled } from "@mui/material";
import { calendarDayName } from "../classes.js";
const doNotForward = /* @__PURE__ */ new Set(["ownerState", "palette", "dayGapX"]);
const Root = styled("div", {
  name: calendarDayName,
  slot: "Root",
  overridesResolver: (_, styles) => [styles.root],
  shouldForwardProp: (prop) => !doNotForward.has(prop)
})(({ theme, dayGapX, palette, ownerState }) => {
  const accentColorAlpha = palette?.accentColor ? alpha(palette.accentColor, 0.1) : theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / 0.1)` : alpha(theme.palette.primary.main, 0.1);
  const selection = ownerState?.selection;
  const isDifferentMonth = ownerState?.day.type === "day" && ownerState.day.isAdjacentMonth;
  return {
    position: "relative",
    paddingLeft: ownerState?.day.firstOfRow ? 0 : dayGapX,
    ...isDifferentMonth && {
      opacity: 0.5
    },
    ...(selection === "rangeMiddle" || selection === "rangeEnd") && {
      background: accentColorAlpha
    }
  };
});
export {
  Root
};
//# sourceMappingURL=Root.js.map
